// Component Name:  AddUser component
// Author: Lavanya S
// Platform: Web
// OS: Windows
// IDE: Visual Studio Code
// Date: 07-05-2025
// Reference: Original
// Description: This is a Add user Modal component. It is used to add and edit the user details
// It is a resuable component used in user and userDetails page to add or edits
// Interfaces: Accepts props
// Maintenance History:  1.0 - First Version
import React, { useEffect, useState } from "react";
import { Row, Col, Input, Label, ModalHeader, ModalBody, ModalFooter, Button, FormGroup } from "reactstrap";
import ReactModal from "react-modal";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { createUser } from "../../api/userAPI";
import { connect } from "react-redux";
import { successToast, warningToast } from "../../store/dbFilter/actions";
import { modalStyle } from "../Utility/styleComponents";
import useIsMounted from "../Utility/useIsMounted";
import LKEditContentImg from "../../assets/images/LK_Icons/LK__Edit Content.svg";
import LKWhiteEditContentImg from "../../assets/images/LK_Icons/LK_white_Edit Content.svg";
import LKDeleteImg from "../../assets/images/LK_Icons/LK_Delete.svg";
import LKWhiteDeleteImg from "../../assets/images/LK_Icons/LK_White_Delete.svg";
import LKCloseImg from "../../assets/images/LK_Icons/LK_Close.svg";
import { ActiveBtn, CancelBtn, InActiveBtn } from "../Utility/Button";
import { inputRequired } from "../Utility/utilsFunctions";
import { userSelected } from "../../store/users/actions";
/**
 * Adduser Modal Component
 * Uses ReactModal and supports Redux-based warning/success messages.
 *
 * @param {Object} userData - name,email,phoneNumber,rfids,payType.
 * @param {boolean} isModalOpen - to toggle modal open and close.
 * @param {Function} closeModal - Callback function to perform any operation on click closeModal.
 */
const AddUser = (props) => {
  const { email, name, phoneNumber, rfids, payType, balance, creditLimit, status } = props?.userData;
  // handle form changes
  const [customerData, setCustomerData] = useState({
    name: "",
    phoneNumber: "",
    email: "",
    balance: 0,
    creditLimit: 0,
    status: "Accepted",
    // hostId:""
  });
  const [rfid, setRfid] = useState([]);
  const [paymentType, setPaymentType] = useState("Prepaid");
  const isMounted = useIsMounted();
  useEffect(() => {
    if (isMounted.current) {
      setCustomerData({
        name: name,
        phoneNumber: phoneNumber,
        email: email,
        balance: balance,
        creditLimit: creditLimit,
        status: status,
      });
    }
    const rfidRemoveItag = rfids;
    // rfids?.length > 0 &&
    // rfids?.map((item) => {
    //   return { idTag: item?.idTag };
    // });
    isMounted.current && rfids?.length > 0 && setRfid(rfidRemoveItag);
    isMounted.current && setPaymentType(payType);
  }, []);

  //   to handle the name,email and phoneNumber change
  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setCustomerData({
      ...customerData,
      [name]: value,
    });
  };
  // update the rfid array
  const handleRFIDChange = (index, value) => {
    const updatedRFIDs = [...rfid];
    updatedRFIDs[index] = value;
    setRfid(updatedRFIDs);
  };

  // to show the input box for the rfid
  const addRFIDField = () => {
    setRfid((prev) => [...prev, ""]);
  };

  // Remove RFID input by index
  const removeRFIDField = (index) => {
    setRfid((prev) => prev.filter((_, i) => i !== index));
  };
  // Handle change in payment type
  const handlePaymentTypeChange = (e) => {
    if (e.target.value === "Postpaid") {
      setPaymentType(e.target.value);
      setRfid([""]);
    } else {
      setPaymentType(e.target.value);
      setRfid([]);
    }
  };

  // reset all the data before closing the modal
  const closeAddUserModal = (isUpdated = false) => {
    setCustomerData({
      name: "",
      phoneNumber: "",
      email: "",
      balance: 0,
      creditLimit: 0,
      status: "Accepted",
    });
    setRfid([{ idTag: "" }]);
    setPaymentType("Prepaid");
    props.closeModal(isUpdated);
  };
  // console.log(":customerData", customerData);

  /**
   * Makes a call to create a new User or update the existing one
   * returns User data on success , fetch all the user and update the table and reset state variables
   * on failure shows err message
   */
  const handleCreateUser = async () => {
    // if payment type is post paid, validate RFID's
    if (paymentType === "Postpaid") {
      const allValidRFIDs = rfid.every((item) => /^[a-zA-Z0-9]{8,16}$/.test(item));
      if (!allValidRFIDs) {
        props.warningToast({ title: "Invalid RFID", message: "All RFIDs must be between 8 to 16-character alphanumeric" });
        return;
      }
    } else {
      setRfid(() => {
        return [];
      });
    }

    try {
      const response = await createUser({ ...customerData, hostId: props?.email, rfids: rfid });
      const { message, data } = response;
      props.userSelected({ ...customerData, hostId: props?.email, rfids: rfid });
      props.successToast({ title: "Success", message: message });
      closeAddUserModal(true);
    } catch (err) {
      console.log("Error creating User:", err.msg);
    }
  };

  var modalWidth = props.layoutType === "vertical" ? "60%" : "95%";
  var modalHeight = props.layoutType === "vertical" ? "75%" : "85%";
  return (
    <ReactModal isOpen={props.isModalOpen} onRequestClose={closeAddUserModal} style={modalStyle(modalWidth, modalHeight)}>
      {/* <ModalHeader toggle={closeAddUserModal}>Customer Details</ModalHeader> */}
      <div className="d-flex justify-content-between align-items-center px-3 mt-2 pb-3 border-bottom">
        <h5 className="m-0"> Customer Details </h5>
        <img src={LKCloseImg} alt="Close" onClick={props.closeModal} style={{ cursor: "pointer", width: "20px", height: "20px", marginLeft: "auto" }} />
      </div>
      <ModalBody>
        <AvForm>
          <Row>
            <Col lg={6}>
              <FormGroup>
                <Label htmlFor="name">Customer Name{inputRequired()}</Label>
                <AvField
                  name="name"
                  type="text"
                  className="form-control"
                  id="name"
                  placeholder="Enter Customer Name"
                  required
                  value={customerData?.name}
                  onChange={handleFormChange}
                />
              </FormGroup>
            </Col>

            <Col lg={6}>
              <FormGroup>
                <Label htmlFor="phoneNumber">Phone Number{inputRequired()}</Label>
                {props?.userData?.phoneNumber?.length > 0 ? (
                  <AvField
                    name="phoneNumber"
                    type="text"
                    className="form-control"
                    id="phoneNumber"
                    placeholder="Enter Phone Number"
                    required
                    value={customerData?.phoneNumber}
                    disabled
                    style={{ cursor: "not-allowed" }}
                  />
                ) : (
                  <AvField
                    name="phoneNumber"
                    type="text"
                    className="form-control"
                    id="phoneNumber"
                    placeholder="Enter Phone Number"
                    required
                    value={customerData?.phoneNumber}
                    onChange={handleFormChange}
                    validate={{
                      required: { value: true, errorMessage: "This field is required" },
                      pattern: {
                        value: /^[0-9]{10}$/,
                        errorMessage: "Must be exact 10 digits ",
                      },
                    }}
                  />
                )}
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col lg={6}>
              <FormGroup>
                <Label htmlFor="credit">Email</Label>
                <AvField name="email" type="email" className="form-control" id="email" placeholder="Enter Email" value={customerData?.email} onChange={handleFormChange} />
              </FormGroup>
            </Col>

            <Col lg={6}>
              <FormGroup>
                <Label htmlFor="creditLimit">Credit Limit</Label>
                <AvField
                  name="creditLimit"
                  type="number"
                  className="form-control"
                  id="creditLimit"
                  placeholder="Enter creditLimit"
                  value={customerData?.creditLimit}
                  onChange={handleFormChange}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col lg={6}>
              <FormGroup>
                <Label htmlFor="balance">Balance</Label>
                <AvField name="balance" type="number" className="form-control" id="balance" placeholder="Enter Balance" value={customerData?.balance} onChange={handleFormChange} />
              </FormGroup>
            </Col>

            <Col lg={6}>
              <FormGroup>
                <Label htmlFor="paymentType">Payment Type</Label>
                <select name="paymentType" className="form-control" id="paymentType" value={paymentType} onChange={handlePaymentTypeChange}>
                  <option value="Prepaid">Prepaid</option>
                  <option value="Postpaid">Postpaid</option>
                </select>
              </FormGroup>
            </Col>
          </Row>
          {paymentType === "Postpaid" && (
            <FormGroup>
              <Label>RFIDs</Label>
              {rfid?.map((item, index) => (
                <div key={index} className="d-flex mb-2 align-items-center">
                  {/* <AvField
                    type="text"
                    name={`idTag-${index}`} // unique name per field in a list
                    placeholder="Enter 16-character RFID"
                    value={item.idTag}
                    onChange={(e) => handleRFIDChange(index, e.target.value)}
                    validate={{
                      required: { value: true, errorMessage: "RFID is required" },
                      pattern: {
                        value: "^[a-zA-Z0-9]{16}$",
                        errorMessage: "RFID must be 16 alphanumeric characters",
                      },
                    }}
                    style={{width:"500px",border:"2px solid red"}}
                  /> */}
                  <Input
                    type="text"
                    placeholder="Enter 16-character RFID"
                    value={item}
                    onChange={(e) => handleRFIDChange(index, e.target.value)}
                    pattern="^[a-zA-Z0-9]{8,16}$/"
                    title="RFID must be 16 alphanumeric characters"
                    required
                  />
                  {/* <Button color="danger" size="sm" onClick={() => removeRFIDField(index)} className="ml-2" disabled={rfid.length === 1}>
                    &minus;
                  </Button> */}
                  {rfid.length === 1 ? (
                    <InActiveBtn image={LKDeleteImg} customWidth={"90px"} />
                  ) : (
                    <ActiveBtn image={LKWhiteDeleteImg} hoverImg={LKDeleteImg} customWidth={"90px"} handleClick={() => removeRFIDField(index)} />
                  )}
                </div>
              ))}
              {/* <Button type="button" color="secondary" size="sm" onClick={addRFIDField}>
                + Add RFID
              </Button> */}
              <span style={{ width: "100px" }}>
                <ActiveBtn name={"Add RFID"} customWidth={"120px"} handleClick={addRFIDField} image={LKWhiteEditContentImg} hoverImg={LKEditContentImg} />
              </span>
            </FormGroup>
          )}

          <ModalFooter className={` ${props.layoutType === "vertical" ? "" : "d-flex flex-column justify-content-center align-items-center"}`}>
            {/* <Button type="button" color="light" onClick={closeAddUserModal}>
              Cancel
            </Button> */}
            <div className="mb-2">
              <CancelBtn name="Cancel" handleClick={closeAddUserModal} />
            </div>
            {/* <Button type="submit" color="primary">
              Save
            </Button> */}
            <div className="mb-2">
              <ActiveBtn name="Save" handleClick={handleCreateUser} />
            </div>
          </ModalFooter>
        </AvForm>
      </ModalBody>
    </ReactModal>
  );
};
const mapStateToProps = (state) => ({
  layoutType: state.Layout.layoutType,
  email: state?.Login?.user?.email,
});
const mapDispatchToProps = (dispatch) => ({
  userSelected: (payload) => dispatch(userSelected(payload)),
  successToast: (payload) => dispatch(successToast(payload)),
  warningToast: (payload) => dispatch(warningToast(payload)),
});
export default connect(mapStateToProps, mapDispatchToProps)(AddUser);
